import { Stack } from '@mui/material';

import {
  Logomark,
  LogomarkSize,
  LogomarkVariant,
} from '@/components/brand/Logomark/Logomark';

import { APPBAR_HEIGHT } from '../../Layout/AppBar/AppBar.constants';

interface SidebarLogoProps {
  isExpanded: boolean;
}

export function SidebarLogo({ isExpanded }: SidebarLogoProps) {
  return (
    <Stack
      data-testid="TenantLogo"
      direction="row"
      minHeight={APPBAR_HEIGHT}
      alignItems="center"
      justifyContent="center"
    >
      <Logomark
        size={isExpanded ? LogomarkSize.Wide : LogomarkSize.Square}
        variant={LogomarkVariant.Primary}
        imageSx={{
          maxHeight: 48,
          maxWidth: isExpanded ? 140 : 48,
          display: 'flex',
        }}
      />
    </Stack>
  );
}
